import { useEffect, useMemo, useState } from 'react'
import { useGetNextBetWindow, useGetNextLoginWindow } from '../store'

export const useDailyCheckInCountdown = () => {
  const nextBetWindow = useGetNextBetWindow()
  const nextLoginWindow = useGetNextLoginWindow()

  const countdownType = useMemo(() => {
    if (!nextBetWindow && !nextLoginWindow) return null
    if (!nextBetWindow) return 'login'
    if (!nextLoginWindow) return 'bet'

    const betTime = nextBetWindow.start.getTime()
    const loginTime = nextLoginWindow.start.getTime()

    return betTime < loginTime ? 'bet' : 'login'
  }, [nextBetWindow, nextLoginWindow])

  // Determine which countdown to show (the shorter one)
  const targetDate = useMemo(() => {
    if (!countdownType) return undefined
    return countdownType === 'bet' ? nextBetWindow?.end : nextLoginWindow?.start
  }, [countdownType, nextBetWindow, nextLoginWindow])

  const [isActive, setIsActive] = useState<boolean>(() =>
    targetDate ? targetDate.getTime() > Date.now() : false
  )

  const targetTs = targetDate?.getTime() ?? null
  useEffect(() => {
    if (!targetTs) {
      setIsActive(false)
      return
    }
    const ms = targetTs - Date.now()
    if (ms <= 0) {
      setIsActive(false)
      return
    }
    setIsActive(true)
    const id = setTimeout(() => { setIsActive(false) }, ms)
    return () => { clearTimeout(id) }
  }, [targetTs])

  return { countdownType, targetDate, isActive }
}
